import axios from 'axios'

import type { components } from '../constants/schema'

/**
 * 로그인 유저 예치금 계좌 정보 (마스킹 O)
 * @returns MaskedDepositAccountDto
 */
export const getDepositAccount = async () => {
  return (await axios.get<components['schemas']['MaskedDepositAccountDto']>('/user/current/depositAccount')).data
}

/**
 * 로그인 유저 예치금 계좌 정보 (마스킹 X)
 * @returns UnmaskedDepositAccountDto
 */
export const getUnmaskedDepositAccount = async () => {
  return (await axios.get<components['schemas']['UnmaskedDepositAccountDto']>('/user/current/depositAccount/unmask'))
    .data
}

/**
 * 로그인 유저 예치금 계좌 생성
 * @param terms 예치금 계좌 생성 약관 동의 여부
 * @returns UnmaskedDepositAccountDto
 */
export const createDepositAccount = async (data: components['schemas']['ReqCreateUserDepositAccountDto']) => {
  try {
    return (await axios.post<components['schemas']['UnmaskedDepositAccountDto']>('/user/current/depositAccount', data))
      .data
  } catch (error) {
    throw error
  }
}

/**
 * 예치금 계좌 출금 요청
 * @param originAmount 출금 금액
 * @returns ReqUserDepositAccountWithdrawalDto
 */
export const withdrawalDepositAccount = async (originAmount: number) => {
  try {
    return (
      await axios.post<components['schemas']['ReqUserDepositAccountWithdrawalDto']>(
        '/user/current/depositAccount/withdrawal',
        { originAmount },
      )
    ).data
  } catch (error) {
    throw error
  }
}
